import React from 'react'
import FeedbackRapido from '../../../../components/performance/FeedbackRapido'

export default function FeedbackQuickPage() {
  return (
    
            <FeedbackRapido />
          
  )
}
